/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 8a6.497 6.497 0 01-5.315 6.39V9.882c.07-.002.14 0 .21-.002h1.3c.098-.628.192-1.255.287-1.888a1.74 1.74 0 00-.227-.005c-.075-.002-.15 0-.225 0H9.188c-.003-.027-.006-.045-.006-.064V6.745A1.15 1.15 0 019.23 6.4a.85.85 0 01.675-.625c.128-.025.258-.037.388-.035.232-.003.465 0 .695 0h.07V4.128c-.078-.01-.155-.026-.236-.033-.272-.03-.542-.063-.817-.08a3.713 3.713 0 00-1.065.053 2.188 2.188 0 00-1.147.62A2.223 2.223 0 007.25 5.69c-.067.261-.1.53-.1.8v1.497H5.5v1.89c.077.008.155.003.235.003.075.002.152 0 .23 0h1.18v4.563A6.5 6.5 0 1114.5 8z"
}));

export default SvgFacebook;